import React from 'react';
import { Check, Gift } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, finalIncludedItems } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const noMore = ['No more hours searching for diagrams and lesson ideas', 'No more disconnected teaching material', 'No more explaining complex systems with long blocks of theory', 'No more repeating the same activities because preparation time ran out', 'No more creating every assessment from an empty page', 'No more wondering what progression should come next', 'No more walking into the workshop with only a loose idea', 'No more building every lesson from scratch'];
const trustPoints = ['Immediate Access', 'Complete Digital Bundle', '6-in-1 Visual Teaching System', '150 Ready-to-Teach Lessons', '5 Professional Bonus Guides'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-primary tech-grid relative overflow-hidden" data-id="element-69" data-mp="zx4pej6ofoz7">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-70" data-mp="2c4wo4ojgcche">
        <div className="text-center mb-16" data-id="element-71" data-mp="2c6hiad1utteq">
          <h2 className="text-3xl md:text-5xl font-display font-bold uppercase mb-8 leading-tight text-white" data-id="element-72" data-mp="2h3hruxxwxeal">
            Next Week You Can Keep Building Every Automotive Lesson From Scratch...
            <br data-id="element-73" data-mp="2r1nrf8w8y8ca" />
            <span className="text-accent" data-id="element-74" data-mp="2r2770iyfckn5">
              Or You Can Open a Complete System and Already Know Where to Start.
            </span>
          </h2>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/5 p-8 rounded-xl border border-white/15" data-id="element-75" data-mp="2v1odnfpl7ntw">
            {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-76" data-mp="34un1uwh69ccz">
                <span className="text-accent mt-1" data-id="element-77" data-mp="39sye1duxvyyd">▸</span>
                <span className="text-white/80" data-id="element-78" data-mp="39uhtj28ru5z3">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-white mb-2" data-id="element-79" data-mp="3epordtfd0gg3">
            Automotive Technology Instructor Ready does not replace your knowledge as an instructor.
          </p>
          <p className="text-xl text-white/80" data-id="element-80" data-mp="1jp4rnj7tonk6">
            It gives you a system for using that knowledge with greater structure, clarity,
            consistency and efficiency.
          </p>
        </div>

        <div className="bg-white border-2 border-accent rounded-2xl p-8 md:p-12 shadow-xl" data-id="element-81" data-mp="1si835lywqqc6">
          <h3 className="text-2xl font-display font-bold uppercase text-primary mb-6 text-center border-b border-primary/10 pb-6" data-id="element-82" data-mp="1nodo4vu8yzjf">
            Everything Included
          </h3>
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-83" data-mp="1xeoroha0r6ps">
            {finalIncludedItems.map(item => <div key={item.label} className="flex items-start gap-3" data-id="element-84" data-mp="2bezkhpuw2vdl">
                {item.kind === 'bonus' ? <Gift size={18} className="text-accent-strong shrink-0 mt-0.5" data-id="element-85" data-mp="27btgypz5viat" /> : <Check size={18} className="text-secondary shrink-0 mt-0.5" data-id="element-86" data-mp="h3kur91vovxu" />}
                <span className="text-sm text-body" data-id="element-87" data-mp="d1zmk10ah5tz">{item.label}</span>
              </div>)}
          </div>
          <div className="text-center" data-id="element-88" data-mp="6xjtpgnz588u">
            <p className="text-xl font-display font-bold tracking-wide text-primary mb-2" data-id="element-89" data-mp="6wi7qh5f71cc">
              AUTOMOTIVE TECHNOLOGY INSTRUCTOR READY
            </p>
            <p className="text-sm text-muted mb-6" data-id="element-90" data-mp="3uani6uvqp7gv">
              150 Ready-to-Teach Automotive Technology Lessons designed to help instructors plan
              less, explain complex vehicle systems more clearly and teach with greater structure in
              the classroom and workshop.
            </p>
            <div className="inline-flex flex-wrap items-baseline justify-center gap-2 bg-primary rounded-lg px-6 py-3 mb-6" data-id="element-91" data-mp="36cyd7yvzbg6k">
              <span className="text-2xl font-display font-bold text-white/80" data-id="element-92" data-mp="3bct25ww71voz">TODAY:</span>
              <span className="text-4xl font-display font-bold text-accent" data-id="element-93" data-mp="14l23mutdggef">$27 USD</span>
            </div>
            <div data-id="element-94" data-mp="19jde97rhquxp">
              <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-95" data-mp="19jwkvsboxwwf">
                GET THE COMPLETE AUTOMOTIVE TECHNOLOGY TEACHING SYSTEM NOW
              </Button>
            </div>
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-muted mb-6" data-id="element-96" data-mp="2vnsjiifo94lo">
              {trustPoints.map(point => <span key={point} data-id="element-97" data-mp="2mof9nonmye0f">• {point}</span>)}
            </div>
            <p className="text-lg font-display font-bold text-primary" data-id="element-98" data-mp="2mqi54o7k4zcj">
              Stop Building Every Lesson From Scratch.
            </p>
            <p className="text-lg font-display font-bold text-secondary" data-id="element-99" data-mp="2czxcriih8r22">
              Open the system. Choose the lesson. Teach.
            </p>
          </div>
        </div>
      </div>
    </section>;
}